import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPalette } from './ColorPalette';

// Import the same backdrop image
import backdropImage1 from './images/BackdropNight.png';

function FAQ() {
  const navigate = useNavigate();
  const colors = getPalette('dark'); // You can change this to 'light' or 'auto' as needed
  
  // State for expandable FAQ items
  const [expandedItems, setExpandedItems] = useState({});

  // Enhanced FAQ data with more questions
  const faqData = [
    {
      id: 1,
      question: "How does Flash Fluency's learning method work?",
      answer: "Flash Fluency uses a three-step approach: First, you pick what you want to learn (vocabulary topics, writing exercises, or our default curriculum). Then, you study through multiple skills - reading, listening, pronunciation, cloze exercises, and translation. Finally, you practice using your new vocabulary in conversation. This method ensures you develop comprehensive language skills while building confidence with familiar words."
    },
    {
      id:2,
      question: "How does my learning order get determined?",
      answer: "When you set your learning order, you're telling us what you want to learn next. But it's not as simple as that.  Let's say your reading and listening are both at 400 vocab know.  You then do our reading exercises a lot and learn 100 new vocab. These 100 vocab are added to your learning order (401-500).  You then decide to select a new active vocab topic.  So for your reading, you'll immediately start learning these new vocab.  But for your listening, because you're 100 vocab behind, you'll actually start learning vocab 401-500 before you start learning the new vocab in the new active vocab topic you just selected.  For this reason, among others, we recommend you progress your skills together."
    }
  ];

  const toggleExpanded = (itemId) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const FAQItem = ({ item }) => (
    <div
      style={{
        border: `1px solid ${colors.borderSilver}`,
        borderRadius: '12px',
        marginBottom: '16px',
        backgroundColor: colors.container,
        boxShadow: `0 2px 8px ${colors.shadow}`,
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        cursor: 'pointer'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = `0 4px 16px ${colors.shadow}`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = `0 2px 8px ${colors.shadow}`;
      }}
    >
      {/* Question header - clickable */}
      <div
        onClick={() => toggleExpanded(item.id)}
        style={{
          padding: '20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: expandedItems[item.id] ? colors.highlight : 'transparent',
          borderBottom: expandedItems[item.id] ? `1px solid ${colors.borderSilver}` : 'none',
          transition: 'all 0.3s ease'
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: '18px',
            color: colors.text,
            fontWeight: '600',
            lineHeight: '1.4',
            paddingRight: '16px'
          }}
        >
          {item.question}
        </h3>
        <div
          style={{
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            backgroundColor: colors.button,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            transition: 'all 0.3s ease'
          }}
        >
          <span
            style={{
              fontSize: '20px',
              color: '#FFFFFF',
              fontWeight: 'bold',
              transform: expandedItems[item.id] ? 'rotate(45deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease'
            }}
          >
            +
          </span>
        </div>
      </div>

      {/* Answer - expandable with smooth animation */}
      <div
        style={{
          maxHeight: expandedItems[item.id] ? '500px' : '0',
          overflow: 'hidden',
          transition: 'max-height 0.3s ease'
        }}
      >
        <div
          style={{
            padding: '20px',
            color: colors.text,
            fontSize: '16px',
            lineHeight: '1.7',
            backgroundColor: colors.container,
            opacity: expandedItems[item.id] ? 1 : 0,
            transition: 'opacity 0.3s ease'
          }}
        >
          {item.answer}
        </div>
      </div>
    </div>
  );

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundImage: `url(${backdropImage1})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundColor: colors.background,
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 10px'
      }}
    >
      {/* Central container */}
      <div
        style={{
          width: '100%',
          maxWidth: '700px',
          backgroundColor: colors.container,
          borderRadius: '16px',
          boxShadow: `0 8px 24px ${colors.shadow}`,
          overflow: 'hidden'
        }}
      >
        {/* Header with back button */}
        <div
          style={{
            padding: '24px',
            borderBottom: `2px solid ${colors.borderSilver}`,
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            background: `linear-gradient(135deg, ${colors.button}15, ${colors.container})`
          }}
        >
          <button
            onClick={() => navigate('/')}
            style={{
              background: colors.button,
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: '#FFFFFF',
              padding: '12px 16px',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s ease',
              boxShadow: `0 2px 8px ${colors.shadow}`
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = `0 4px 12px ${colors.shadow}`;
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = `0 2px 8px ${colors.shadow}`;
            }}
          >
            ←
          </button>
          <div>
            <h1
              style={{
                margin: 0,
                fontSize: '28px',
                color: colors.text,
                fontWeight: '700',
                marginBottom: '4px'
              }}
            >
              Frequently Asked Questions
            </h1>
            <p
              style={{
                margin: 0,
                fontSize: '16px',
                color: colors.text,
                opacity: 0.7
              }}
            >
              Find answers to common questions about Flash Fluency
            </p>
          </div>
        </div>

        {/* FAQ Content */}
        <div
          style={{
            padding: '32px 24px'
          }}
        >
          

          {/* FAQ Items */}
          <div>
            {faqData.map(item => (
              <FAQItem key={item.id} item={item} />
            ))}
          </div>

          {/* Contact section */}
          {/* <div
            style={{
              marginTop: '48px',
              padding: '32px',
              background: `linear-gradient(135deg, ${colors.button}20, ${colors.highlight})`,
              borderRadius: '16px',
              textAlign: 'center',
              border: `2px solid ${colors.button}30`
            }}
          >
            <h3
              style={{
                margin: '0 0 12px 0',
                color: colors.text,
                fontSize: '24px',
                fontWeight: '700'
              }}
            >
              Still have questions?
            </h3>
            <p
              style={{
                margin: '0 0 24px 0',
                color: colors.text,
                fontSize: '16px',
                opacity: 0.8,
                lineHeight: '1.5'
              }}
            >
              Reach out to us and we'll get back to you as soon as possible.
            </p>
            <button
              onClick={() => navigate('/support')}
              style={{
                backgroundColor: colors.button,
                color: '#FFFFFF',
                border: 'none',
                padding: '16px 32px',
                borderRadius: '12px',
                fontSize: '18px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: `0 4px 16px ${colors.shadow}`,
                transition: 'all 0.3s ease',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = `0 6px 20px ${colors.shadow}`;
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = `0 4px 16px ${colors.shadow}`;
              }}
            >
              <span style={{ fontSize: '20px' }}>📧</span>
              Contact Support
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default FAQ;